module.exports = __webpack_public_path__ + "img/scene-loading.f1fe22c1.gif";